import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import {ProductIngredient} from '../restaurant-manager.models';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IngredientService {

  constructor(private apiService: ApiService) {}

  list(): Observable<ProductIngredient[]> {
    return this.apiService.get<ProductIngredient[]>('/ingredients').pipe(map(ingredients => {
      return ingredients.map(i => new ProductIngredient(i));
    }));
  }

}
